import React, { SetStateAction, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Badge,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles } from './styles';
import { generateId } from '../../pages/AddSurveillance/utils';
import { CoordinatorObject } from '../../@types/surveilanceTypes';
import CoordinatorForm from './CoordinatorForm';

const initialCoordinator: CoordinatorObject = {
  index: 0,
  Matrícula: '',
  _localId: '',
};

interface IProps {
  coordinators: CoordinatorObject[];
  setCoordinators: React.Dispatch<SetStateAction<CoordinatorObject[]>>;
  formErrors: { key: string; message: string }[];
  setFormErrors: React.Dispatch<SetStateAction<{ key: string; message: string }[]>>;
}

const CoordinatorFormGroup: React.FC<IProps> = ({
  coordinators,
  setCoordinators,
  formErrors,
  setFormErrors,
}) => {
  const [errors, setErrors] = useState<{ key: string; message: string }[]>([]);
  const classes = useStyles();

  const addNewCoordinator = () => {
    const list = [...coordinators];
    list.push({
      ...initialCoordinator,
      index: coordinators.length,
      _localId: generateId(),
    });
    setCoordinators(list);
    setFormErrors((prev) => {
      const errorList = [...prev].filter((item) => {
        return item.key !== 'missionCoord';
      });
      return errorList;
    });
  };

  const deleteCoordinator = (index: number) => {
    const list = [...coordinators]
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setCoordinators([...list]);
  };

  const changeCoordinatorState = (coordinator: CoordinatorObject) => {
    const list = [...coordinators];
    list[coordinator.index] = coordinator;
    setCoordinators(list);
  };

  useEffect(() => {
    const coordErrors = formErrors.filter((item) => {
      return item.key === 'missionCoord';
    });
    setErrors(coordErrors);
  }, [formErrors]);

  return (
    <Badge
      color="secondary"
      badgeContent={errors.length}
      invisible={!errors.length}
      style={{ width: '100%' }}
    >
      <Accordion className={classes.accordionContainer}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="h6">Coordenador da Missão</Typography>{' '}
        </AccordionSummary>
        <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <div className={classes.addButtonContainer}>
              <Button
                color="default"
                variant="outlined"
                endIcon={<Add />}
                className={classes.addButton}
                onClick={() => addNewCoordinator()}
              >
                Adicionar
              </Button>
            </div>

            {coordinators.map((item) => {
              return (
                <CoordinatorForm
                  key={item._localId}
                  coordinatorObject={item}
                  deleteCoordinator={deleteCoordinator}
                  changeCoordinatorState={changeCoordinatorState}
                  formErrors={formErrors}
                />
              );
            })}
          </div>
        </AccordionDetails>
      </Accordion>
    </Badge>
  );
};

export default CoordinatorFormGroup;
